import { render } from "./PortfolioList.vue?vue&type=template&id=eb2322f6&scoped=true"
import script from "./PortfolioList.vue?vue&type=script&lang=js"
export * from "./PortfolioList.vue?vue&type=script&lang=js"

import "./PortfolioList.vue?vue&type=style&index=0&id=eb2322f6&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb2322f6"]])

export default __exports__